import { UserManager, WebStorageStateStore, Log } from "oidc-client-ts";
import { useRuntimeConfig } from "#imports";
import { createConsola } from "consola";
let oidcClient;
const consola = createConsola({
  fancy: true
});
export const getOidcClient = () => {
  if (oidcClient)
    return oidcClient;
  const config = useRuntimeConfig();
  if (config.public.auth.debug) {
    Log.setLogger(consola);
  }
  oidcClient = new UserManager({
    ...config.public.auth,
    userStore: new WebStorageStateStore()
  });
  return oidcClient;
};
